import React from 'react'
import { HiddenSvg, IPHONE_14_CROPPED_FRAME_SYMBOL_ID } from './IPhone14CroppedFrame'

export function IPhone14CroppedFrameSymbolDefinition() {
  return (
    <HiddenSvg>
      <symbol
        id={IPHONE_14_CROPPED_FRAME_SYMBOL_ID}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 410 598"
        xmlSpace="preserve"
      >
        <g>
          <g>
            <path
              id="Status_Background"
              fill="#fff"
              d="M17.5,73l0-9.6c0-25.6,20.7-46.3,46.3-46.3h282.3c25.6,0,46.4,20.8,46.4,46.4l0,9.5H17.5z"
            />
            <g id="Camera">
              <path
                d="M162.6,28.7h85c9.5,0,17.2,7.7,17.2,17.2s-7.7,17.2-17.2,17.2l0,0h-85c-9.5,0-17.2-7.7-17.2-17.2C145.4,36.4,153.1,28.7,162.6,28.7z"
              />
              <path
                fill="#2e2e2e"
                d="M247.6,51.6c3.2,0,5.7-2.6,5.7-5.7c0-3.2-2.6-5.7-5.7-5.7c-3.2,0-5.7,2.6-5.7,5.7l0,0C241.9,49,244.4,51.6,247.6,51.6z"
              />
            </g>
            <path
              d="M17.5,598V70.7c0-29.5,23.9-53.5,53.5-53.5H339c29.5,0,53.5,24,53.5,53.5V598H410V70.7c0-39.3-31.6-70.6-71-70.7H71C31.6,0,0,31.4,0,70.7V598H17.5z"
            />
            <g id="Status_Bar">
              <g>
                <path
                  fill="d1d1d6"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M300.1,42.6h1.1c0.6,0,1.1,0.5,1.1,1.1v6.5c0,0.6-0.5,1.1-1.1,1.1h-1.1c-0.6,0-1.1-0.5-1.1-1.1v-6.5C299.1,43.1,299.5,42.6,300.1,42.6z"
                />
                <path
                  fill="d1d1d6"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M295.3,44.8h1.1c0.6,0,1.1,0.5,1.1,1.1v4.3c0,0.6-0.5,1.1-1.1,1.1h-1.1c-0.6,0-1.1-0.5-1.1-1.1v-4.3C294.2,45.3,294.8,44.8,295.3,44.8z"
                />
                <path
                  fill="d1d1d6"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M290.4,46.4h1.1c0.6,0,1.1,0.5,1.1,1.1v2.7c0,0.6-0.5,1.1-1.1,1.1h-1.1c-0.6,0-1.1-0.5-1.1-1.1v-2.7C289.3,46.9,289.8,46.4,290.4,46.4z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M305,40.4h1.1c0.6,0,1.1,0.5,1.1,1.1v8.7c0,0.6-0.5,1.1-1.1,1.1H305c-0.6,0-1.1-0.5-1.1-1.1v-8.7C303.9,40.9,304.4,40.4,305,40.4z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M300.1,42.6h1.1c0.6,0,1.1,0.5,1.1,1.1v6.5c0,0.6-0.5,1.1-1.1,1.1h-1.1c-0.6,0-1.1-0.5-1.1-1.1v-6.5C299.1,43.1,299.5,42.6,300.1,42.6z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M295.3,44.8h1.1c0.6,0,1.1,0.5,1.1,1.1v4.3c0,0.6-0.5,1.1-1.1,1.1h-1.1c-0.6,0-1.1-0.5-1.1-1.1v-4.3C294.2,45.3,294.8,44.8,295.3,44.8z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M290.4,46.4h1.1c0.6,0,1.1,0.5,1.1,1.1v2.7c0,0.6-0.5,1.1-1.1,1.1h-1.1c-0.6,0-1.1-0.5-1.1-1.1v-2.7C289.3,46.9,289.8,46.4,290.4,46.4z"
                />
                <path
                  d="M321.9,48c0.7,0,1.4,0.2,2,0.5l0.2,0.1c0.2,0.1,0.2,0.4,0.1,0.5l-2.1,2c-0.1,0.1-0.3,0.1-0.5,0l-2-2c-0.1-0.1-0.1-0.4,0.1-0.5l0.2-0.1C320.6,48.1,321.2,48,321.9,48z"
                />
                <path
                  d="M321.9,44.2c1.7,0,3.4,0.6,4.7,1.6l0.2,0.1c0.2,0.1,0.2,0.3,0,0.5l-1.2,1.2c-0.1,0.1-0.3,0.1-0.4,0l-0.1-0.1c-0.9-0.7-2-1-3.1-1s-2.3,0.4-3.2,1.1l-0.1,0.1c-0.1,0.1-0.3,0.1-0.4,0l-1.2-1.2c-0.1-0.1-0.1-0.4,0-0.5l0.2-0.1C318.6,44.8,320.2,44.2,321.9,44.2z"
                />
                <path
                  d="M321.9,40.4c2.7,0,5.4,1,7.4,2.7l0.2,0.2c0.1,0.1,0.2,0.3,0,0.5l-1.2,1.2c-0.1,0.1-0.3,0.1-0.4,0l-0.2-0.1c-1.6-1.4-3.7-2.1-5.8-2.1c-2.1,0-4.2,0.7-5.8,2.1l-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0l-1.2-1.2c-0.1-0.1-0.1-0.3,0-0.5l0.2-0.2C316.6,41.4,319.2,40.4,321.9,40.4z"
                />
                <path
                  fill="#3c3c43"
                  fillOpacity="0.6"
                  d="M360.8,43.7L360.8,43.7c0.6,0,1.1,0.5,1.1,1.1V47c0,0.6-0.5,1.1-1.1,1.1l0,0V43.7z"
                />
                <path
                  fill="#3c3c43"
                  fillOpacity="0.6"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M338.1,39.3h18.4c1.8,0,3.2,1.5,3.2,3.2v6.6c0,1.8-1.5,3.2-3.2,3.2h-18.4c-1.8,0-3.2-1.5-3.2-3.2v-6.5C334.8,40.8,336.3,39.3,338.1,39.3z M338.1,40.4c-1.2,0-2.2,1-2.2,2.2v6.5c0,1.2,1,2.2,2.2,2.2h18.4c1.2,0,2.2-1,2.2-2.2v-6.5c0-1.2-1-2.2-2.2-2.2H338.1z"
                />
                <path
                  d="M338.1,41.5h18.4c0.6,0,1.1,0.5,1.1,1.1v6.5c0,0.6-0.5,1.1-1.1,1.1h-18.4c-0.6,0-1.1-0.5-1.1-1.1v-6.5C337,42,337.5,41.5,338.1,41.5z"
                />
              </g>
              <g>
                <path
                  d="M73.2,51.4c2.9,0,4.6-2.3,4.6-6.1c0-1.5-0.3-2.7-0.8-3.6c-0.8-1.5-2.1-2.3-3.8-2.3c-2.5,0-4.3,1.7-4.3,4c0,2.2,1.6,3.8,3.8,3.8c1.3,0,2.4-0.6,3-1.7l0,0l0,0h0.1c0,2.6-1,4.2-2.7,4.2c-1,0-1.7-0.5-2-1.4h-2C69.5,50.1,71.1,51.4,73.2,51.4z M73.3,45.6c-1.3,0-2.3-0.9-2.3-2.2s1-2.3,2.3-2.3s2.3,1,2.3,2.3C75.5,44.6,74.6,45.6,73.3,45.6z"
                />
                <path
                  d="M81.2,51.3c0.8,0,1.3-0.5,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3c-0.7,0-1.3,0.5-1.3,1.3C79.9,50.7,80.4,51.3,81.2,51.3zM81.2,45.3c0.8,0,1.3-0.5,1.3-1.2s-0.5-1.3-1.3-1.3c-0.7,0-1.3,0.5-1.3,1.3C79.9,44.8,80.4,45.3,81.2,45.3z"
                />
                <path
                  d="M89.9,51.1h2V49h1.5v-1.7h-1.5v-7.6H89c-2,3-3.6,5.6-4.7,7.5V49h5.6V51.1z M86.2,47.1c1.3-2.3,2.5-4.2,3.6-5.8h0.1v6h-3.7V47.1z"
                />
                <path d="M97.8,51.1h2V39.6h-2l-3,2.1v2l2.8-2h0.1L97.8,51.1L97.8,51.1z" />
              </g>
            </g>
          </g>
        </g>
      </symbol>
    </HiddenSvg>
  )
}
